export default __webpack_public_path__ + "static/media/Twitter.7f7b4904.svg";